import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import {Detail} from './pages/Detail'
import Home from "./pages/Home/Home";
import './App.scss'
import { List } from './pages/List';
import { BList } from './pages/BList';
import { PList } from './pages/PList';
import { PDetail } from './pages/PDetail';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route exact path='/detail/:id' component={Detail} />
        <Route path='/list/:id' component={List} />
        <Route path='/blist/:id' component={BList} />
        <Route path='/plist/:id' component={PList} />
        <Route path='/pdetail/:id' component={PDetail} />
      </Layout>
    );
  }
}
